import type { ServiceCategory } from '@makhe/shared';

const CRAFT_CHIPS: { label: string; category?: ServiceCategory; q?: string }[] = [
  { label: 'All' },
  { label: 'Hair', category: 'hair' },
  { label: 'Nails', category: 'nails' },
  { label: 'Brows & lashes', category: 'brows_lashes' },
  { label: 'Barbering', category: 'barbering' },
  { label: 'Makeup', category: 'makeup' },
  { label: 'Braids', q: 'braids' },
  { label: 'Fades', q: 'fade' },
];

export function CraftChipBar({
  onPick,
}: {
  onPick: (opts: { q?: string; category?: ServiceCategory }) => void;
}) {
  return (
    <section className="border-t border-makhe-line bg-makhe-paper">
      <div className="mx-auto max-w-6xl px-5 py-8">
        <p className="eyebrow mb-4">Browse by craft</p>
        <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
          {CRAFT_CHIPS.map((chip) => (
            <button
              key={chip.label}
              type="button"
              onClick={() => onPick({ category: chip.category, q: chip.q })}
              className="shrink-0 rounded-full border border-makhe-line bg-makhe-bg px-4 py-2 text-xs font-medium text-makhe-ink transition-colors hover:border-makhe-brand hover:bg-makhe-brand hover:text-makhe-on"
            >
              {chip.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
